import { HoldScrollPage } from "./functions/HoldScrollPage";

const getCookieYesConsent = () => {
  if (typeof window.getCkyConsent !== "function") {
    console.warn("CookieYes: getCkyConsent not found");
    return {};
  }
  const consentData = window.getCkyConsent();
  if (!consentData || !consentData.categories) {
    console.warn("CookieYes: failed to get consent data");
    return {};
  }
  return consentData.categories;
};

function handleCookieYesModal(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      const modal = mutation.target as HTMLElement;
      HoldScrollPage(modal.classList.contains("cky-modal-open"));
      if (modal.classList.contains("cky-modal-open")) {
        console.log("CookieYes configuration modal opened");
        // Add any additional logic you want to execute when the modal opens
      } else {
        console.log("CookieYes configuration modal closed");
        // Add any additional logic you want to execute when the modal closes
      }
    }
  }
}

export default defineNuxtPlugin(async (nuxtApp) => {
  const gtm = useGtm();
  function updateGTMConsent() {
    if (window.cookieyes) {
      const consents = getCookieYesConsent();
      const isAnalyticsAccepted = consents.analytics; // Check if analytics cookies are accepted
      gtm?.enable(isAnalyticsAccepted); // Enable/disable GTM
    }
  }

  // Call on page load
  if (import.meta.client) {
    document.addEventListener("cookieyes_consent_update", updateGTMConsent);

    // Check consent immediately after CookieYes loads
    setTimeout(() => {
      updateGTMConsent();
      const observer = new MutationObserver(handleCookieYesModal);
      const modal = document.querySelector(".cky-modal");
      if (modal) observer.observe(modal, { attributes: true });
    }, 1000);
  }
});
